export interface ITypographyParameters {
    fontWeight: string;
    fontSize: string;
    letterSpacing: string;
    paragraphSpacing: string;
    textCase: string;
    textDecoration: string;
    lineHeight: string;
}

export interface ITypography {
    "heading-6x-large-regular": ITypographyParameters;
    "heading-6x-large-medium": ITypographyParameters;
    "heading-6x-large-semibold": ITypographyParameters;
    "heading-6x-large-bold": ITypographyParameters;
    "heading-5x-large-regular": ITypographyParameters;
    "heading-5x-large-medium": ITypographyParameters;
    "heading-5x-large-semibold": ITypographyParameters;
    "heading-5x-large-bold": ITypographyParameters;
    "heading-4x-large-regular": ITypographyParameters;
    "heading-4x-large-medium": ITypographyParameters;
    "heading-4x-large-semibold": ITypographyParameters;
    "heading-4x-large-bold": ITypographyParameters;
    "heading-3x-large-regular": ITypographyParameters;
    "heading-3x-large-medium": ITypographyParameters;
    "heading-3x-large-semibold": ITypographyParameters;
    "heading-3x-large-bold": ITypographyParameters;
    "heading-xx-large-regular": ITypographyParameters;
    "heading-xx-large-medium": ITypographyParameters;
    "heading-xx-large-semibold": ITypographyParameters;
    "heading-xx-large-bold": ITypographyParameters;
    "heading-x-large-regular": ITypographyParameters;
    "heading-x-large-medium": ITypographyParameters;
    "heading-x-large-semibold": ITypographyParameters;
    "heading-x-large-bold": ITypographyParameters;
    "heading-large-regular": ITypographyParameters;
    "heading-large-medium": ITypographyParameters;
    "heading-large-semibold": ITypographyParameters;
    "heading-large-bold": ITypographyParameters;
    "heading-medium-regular": ITypographyParameters;
    "heading-medium-medium": ITypographyParameters;
    "heading-medium-semibold": ITypographyParameters;
    "heading-medium-bold": ITypographyParameters;
    "heading-regular-regular": ITypographyParameters;
    "heading-regular-medium": ITypographyParameters;
    "heading-regular-semibold": ITypographyParameters;
    "heading-regular-bold": ITypographyParameters;
    "heading-small-regular": ITypographyParameters;
    "heading-small-medium": ITypographyParameters;
    "heading-small-semibold": ITypographyParameters;
    "heading-small-bold": ITypographyParameters;
    "heading-x-small-regular": ITypographyParameters;
    "heading-x-small-medium": ITypographyParameters;
    "heading-x-small-semibold": ITypographyParameters;
    "heading-x-small-bold": ITypographyParameters;
    "label-large-regular": ITypographyParameters;
    "label-large-medium": ITypographyParameters;
    "label-large-semibold": ITypographyParameters;
    "label-large-bold": ITypographyParameters;
    "label-medium-regular": ITypographyParameters;
    "label-medium-medium": ITypographyParameters;
    "label-medium-semibold": ITypographyParameters;
    "label-medium-bold": ITypographyParameters;
    "label-regular-regular": ITypographyParameters;
    "label-regular-medium": ITypographyParameters;
    "label-regular-semibold": ITypographyParameters;
    "label-regular-bold": ITypographyParameters;
    "label-small-regular": ITypographyParameters;
    "label-small-medium": ITypographyParameters;
    "label-small-semibold": ITypographyParameters;
    "label-small-bold": ITypographyParameters;
    "label-x-small-regular": ITypographyParameters;
    "label-x-small-medium": ITypographyParameters;
    "label-x-small-semibold": ITypographyParameters;
    "label-x-small-bold": ITypographyParameters;
    "paragraph-large-regular": ITypographyParameters;
    "paragraph-large-medium": ITypographyParameters;
    "paragraph-large-semibold": ITypographyParameters;
    "paragraph-large-bold": ITypographyParameters;
    "paragraph-medium-regular": ITypographyParameters;
    "paragraph-medium-medium": ITypographyParameters;
    "paragraph-medium-semibold": ITypographyParameters;
    "paragraph-medium-bold": ITypographyParameters;
    "paragraph-regular-regular": ITypographyParameters;
    "paragraph-regular-medium": ITypographyParameters;
    "paragraph-regular-semibold": ITypographyParameters;
    "paragraph-regular-bold": ITypographyParameters;
    "paragraph-small-regular": ITypographyParameters;
    "paragraph-small-medium": ITypographyParameters;
    "paragraph-small-semibold": ITypographyParameters;
    "paragraph-small-bold": ITypographyParameters;
    "paragraph-x-small-regular": ITypographyParameters;
    "paragraph-x-small-medium": ITypographyParameters;
    "paragraph-x-small-semibold": ITypographyParameters;
    "paragraph-x-small-bold": ITypographyParameters;
}

export type TTypographyVariant = keyof ITypography;
